import types from './types';

const InitialState = {
    loaded: false,
    boxes: null,
    box: null,
    buttons: {
        open: false,
        prize_redeem: false,
        prize_sell: false
    }
} 

export default (state = InitialState, {type, payload}) => {
    switch(type) {
        case types.toggleButton:
            return {
                ...state,
                buttons: {
                    ...state.buttons,
                    [payload]: !state.buttons[payload]
                }
            }
        case types.box.update:
            return {
                ...state,
                box: {
                    ...state.box,
                    ...payload
                }
            }
        case types.box.loaded:
            return {
                ...state,
                box: payload
            }
        case types.loaded:
            return {
                ...state,
                loaded: true,
                boxes: payload.boxes
            }
        default:
            return state;
    }
}